import { parseErrCode } from '../../components/trustlyIframe/trustlyUtils.ts';
import { FeErrorCode, mapBeReasonToFe } from './errorCodes.ts';

export type BeErrorEnvelope = {
  errCode?: string | null;
  errMsg?: string | null;
};

export type ParsedBeError = {
  feCode: FeErrorCode;
  cause: Record<string, unknown>;
};

export const parseBeError = (body?: BeErrorEnvelope | null): ParsedBeError | undefined => {
  const { code, availableAmount } = parseErrCode(body?.errCode ?? undefined);
  if (!code) return undefined;

  return {
    feCode: mapBeReasonToFe(code),
    cause:  {
      errCode:          code,
      errMsg:           body?.errMsg ?? undefined,
      available_amount: availableAmount,
    },
  };
};

export const toIsoTimestamp = (createdAt?: number | string): string => {
  if (typeof createdAt === 'number') {
    return new Date(createdAt * 1000).toISOString();
  }

  const parsed = createdAt ? new Date(createdAt) : new Date(NaN);

  return Number.isNaN(parsed.getTime()) ? new Date().toISOString() : parsed.toISOString();
};
